import { render, staticRenderFns } from "./CallDeletePhoneIssues.vue?vue&type=template&id=3f4fc134"
import script from "./CallDeletePhoneIssues.vue?vue&type=script&lang=js"
export * from "./CallDeletePhoneIssues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports